import type { FaireProductEntity } from "../../entity_types/product";

export const p_gv3w4cnez5: FaireProductEntity = {
  token: "p_gv3w4cnez5",
  type: "product",
  name: "Sea Salt & Vinegar Kettle Cooked Potato Chips",
  brandToken: "b_7czabpidt2",
  brandName: "Deep River Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/4832a7d79af5a96d9fb8befcc69c323485b214ea9cee005eb71a6f9b02945945.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc16f8b50ea9685cc8f6dc371fd4ec5561a60286b4f0da2da7557261dbf542ff.png",
    "https://cdn.faire.com/fastly/9363e9d0d42cc7d7711a1d9b55791df17cd3794b441ba6eff340ecfa12e63d09.png",
  ],
  priceDollars: 41.56,
  description:
    "The combination of savory sea salt and tart vinegar makes for a delectable New England classic!",
  tags: [],
  msrpDollars: 83.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:11.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
